export const meetingParticipantRole = {
    PARTICIPANT: 'PARTICIPANT',
    GUEST: 'GUEST',
    ORGANIZER: 'ORGANIZER',
};
